import { QueryConstraint, Unsubscribe } from "firebase/firestore";
import Recharge from "../entities/recharges";
import FirestorePipe from "../utils/pipe";
import EstablishmentDB from "./establishment";

class RechargesDB extends FirestorePipe {

  public static readonly colName = 'Recharges'

  constructor(idEstab: string) {
    if(!idEstab)
      throw new Error('Informe o id do estabelecimento')
    super(`${EstablishmentDB.colName}/${idEstab}/${RechargesDB.colName}`);
  }

  public async create(data: any): Promise<any> {
    return this._create(data);
  }
  public async update(id: string, data: Recharge): Promise<any> {
    return this._update(id, data);
  }
  public async delete(id: string): Promise<any> {
    
  }
  public getAll(...params: QueryConstraint[]): Promise<Recharge[]> {
    return this._getAll<Recharge>(...params);
  }
  public get(id: string): Promise<Recharge> {
    return this._get(id);
  }
  public on(listener: (data: Recharge[]) => void, ...params: QueryConstraint[]): Unsubscribe {
    return this._on(listener, ...params);
  }
}

export default RechargesDB;